<ion-header>
  <ion-toolbar>
    <ion-title>Kommentar bearbeiten</ion-title>

    <ion-buttons slot="end">
      <ion-button (click)="close()">Schließen</ion-button>
    </ion-buttons>
  </ion-toolbar>
  
</ion-header>
<ion-content>
  <ion-list>
    <ion-item>
      <ion-label position="stacked">Aktuelle Bemerkung</ion-label>
      <ion-text [innerHTML]="comment | nl2br"></ion-text>
    </ion-item>
    <ion-item>
        <ion-label position="stacked">Neue Bemerkung</ion-label>
        <ion-textarea #textarea rows="10" cols="20" [autofocus]="true" inputmode="text" [(ngModel)]="newComment" name="comment"></ion-textarea>
    </ion-item>
    
      
  
  </ion-list> 
 
</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-button expand="block" (click)="close(newComment)">Speichern</ion-button>
  </ion-toolbar>
</ion-footer>
